"use client";

import { Link } from "@/i18n/navigation";
import Image from "next/image";
import { useMemo } from "react";
import { useLocale } from "next-intl";
import { getLocalizedPath } from "@/utils/pathUtils";
import { PATHS } from "@/constants/pathnames";

export default function PopularHotelsCard({ item }) {
  //POPULAR Hotels api not implemented yet
  const locale = useLocale();

  const link = useMemo(() => {
    const localizedUrl = getLocalizedPath(PATHS.HOTEL_LANDING.PATH, locale);

    return localizedUrl.replace("[landingPageName]", item?.Slug);
  }, [locale]);

  return (
    <Link key={item.OutgoingDepartureDate} href={link} className="w-full gap-4 flex shrink-0 basis-[75%] sm:basis-[35%] mr-4 lg:mr-6 lg:basis-[23.3%] xl:basis-[23.5%]">
      <div className="flex w-full min-w-[294px] flex-col gap-4 lg:min-w-[196px] xl:min-w-[294px]">
        {" "}
        <div className="relative aspect-[294/165] overflow-hidden rounded-lg shadow-sm lg:aspect-[196/110] xl:aspect-[294/165]">
          <Image
            src={item?.ImageUrl || "/images/dummy/blog-dummy-3.jpg"}
            alt="cheapestflight-image"
            fill
            className="object-cover"
          />
        </div>
        <div className="text-foreground text-large font-semibold text-wrap">
          {item?.Name}
        </div>
      </div>
    </Link>
  );
}
